<template>
    <CompassModal
        v-model:visible="showModal"
        size="medium"
        :title="$t.__('documents.DocEditRowAccountingCode.edit_accounting_code')"
        class="doc-edit-row-accounting-code"
        @closed="handleClose"
    >
        <template #default>
            <div class="dialog__default">
                <p class="typographies-paragraph-medium-regular">
                    {{ $l10n.__('Choisissez un code comptable pour modification.') }}
                    {{
                        $l10n.__(
                            'Si vous ne trouvez pas le code souhaité, commencez à le saisir pour le rechercher.',
                        )
                    }}
                </p>

                <el-form labelWidth="120px">
                    <el-form-item :label="$t.__('common.labels.accounting_code')">
                        <el-select
                            v-model="accountingCodeId"
                            class="select-account-code"
                            filterable
                            remote
                            reserveKeyword
                            :placeholder="
                                $t.__('documents.DocEditRowAccountingCode.select_accounting_code')
                            "
                            :remoteMethod="getAccountingCodes"
                        >
                            <el-option
                                v-for="item in accountingCodes"
                                :key="item.id"
                                :label="item.code + ' - ' + item.label"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="handleClose"
                />
                <CompassButton
                    :label="$t.__('common.actions.edit')"
                    type="primary"
                    :loading="loading"
                    class="ml-3"
                    @click="update()"
                />
            </div>
        </template>
    </CompassModal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('documentOverview');

export default {
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        hasDefaultCode: {
            type: Boolean,
            required: false,
            default: false,
        },
        rowtype: {
            type: String,
            required: false,
            default: '',
        },
    },

    data() {
        return {
            showModal: true,
            accountingCodeId: this.actualAccountingCode,
            loading: false,
        };
    },

    computed: {
        actualAccountingCode: function () {
            const row = this.rows.find((row) => row.id == this.seletedRow);
            this.accountingCodeId = row.accountingCodeId;
            return row.accountingCodeId;
        },
        ...mapState({
            accountingCodes(state) {
                if (this.hasDefaultCode) {
                    const withDefault = state.accountingCodes.filter((code) => code.id != 0);
                    if (this.rowtype == 'item' || this.rowtype == 'service') {
                        return [
                            {
                                id: '0',
                                label: this.$l10n.__('Tel que défini dans le catalogue'),
                                code: this.$l10n.__('Par défaut'),
                            },
                        ].concat(withDefault);
                    }
                    return [
                        {
                            id: '0',
                            label: this.$l10n.__('Tel que défini dans le paramétrage'),
                            code: this.$l10n.__('Par défaut'),
                        },
                    ].concat(withDefault);
                }
                return state.accountingCodes;
            },
            seletedRow: 'seletedRow',
            rows: 'rows',
        }),
    },
    created: function () {
        this.loading = true;

        this.getAccountingCodes().then(() => {
            this.getAccountingCodeForRow().then(() => {
                this.accountingCodeId = this.actualAccountingCode;
                this.loading = false;
            });
        });
    },

    methods: {
        update: function () {
            this.loading = false;

            this.$store
                .dispatch('documentOverview/setAccountingCodeForRow', this.accountingCodeId)
                .then(() => {
                    const code = this.accountingCodes.find(
                        (code) => code.id == this.accountingCodeId,
                    ).code;
                    this.loading = false;
                    /**
                     * @todo : remove this jquery call when 'resume' will in Vue.js
                     */
                    $(`#row_${this.seletedRow}_accounting`).text(code);
                    this.handleClose();
                })
                .catch(() => (this.loading = false));
        },
        handleClose() {
            EventBus.emit('docEditRowAccountingCode:close');
        },
        ...mapActions(['getAccountingCodes', 'getAccountingCodeForRow']),
    },
};
</script>

<style lang="scss" scoped>
.doc-edit-row-accounting-code {
    .dialog {
        &__default {
            padding-bottom: var(--spacing-4);
            p {
                margin-top: 0;
                margin-bottom: var(--spacing-3);
            }
            .el-form {
                margin-bottom: 0;
                &-item {
                    margin-bottom: 0;
                    .select-account-code {
                        width: 480px;
                    }
                }
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 var(--spacing-5) var(--spacing-4);
        }
    }
}
</style>
